/* TUZEX: v sekcii značky skryť názov značky pred modelom („Nike Air Max Plus“ → „Air Max Plus“), čísla nechať („Jordan 4“). */
window.txModelLabel=function(brand,name){name=String(name||'');var b=String(brand||'').replace(/^\+/,'').trim();if(!b)return name;var aliases=[b];if(/fear of god essentials/i.test(b))aliases.push('Essentials','Fear of God');if(/^yeezy$/i.test(b))aliases.push('adidas Yeezy');for(var i=0;i<aliases.length;i++){var a=aliases[i];if(name.toLowerCase().indexOf(a.toLowerCase()+' ')===0){var rest=name.slice(a.length+1).trim();if(rest&&!/^\d/.test(rest))return rest;}}return name;};
(() => {if(window.tuzexCatalogInitialized)return;window.tuzexCatalogInitialized=true;function init(root){
if(root.dataset.ready)return;root.dataset.ready='true';
const controller=new AbortController(),signal=controller.signal;
let previousOverflow='';
const raw=JSON.parse(root.querySelector('[data-tx-tree]').textContent);
const art=JSON.parse(root.querySelector('[data-tx-art]').textContent);
const safeUrl=value=>{const url=String(value||'').trim();return /^(\/|https?:\/\/|#|mailto:|tel:)/i.test(url)?url:'#';};
const pair=line=>{const i=line.indexOf('|');return [line.slice(0,i<0?undefined:i).trim(),safeUrl(i<0?'#':line.slice(i+1))];};
function groups(text){const result=[];String(text||'').split(/\r?\n/).forEach(line=>{if(!line.trim())return;const child=line.trim().startsWith('>');const item=pair(line.trim().replace(/^>\s*/,''));if(child&&result.length)result[result.length-1].models.push(item);else if(!child)result.push({name:item[0],href:item[1],models:[]});});return result;}
const categoryKey = value => fold(String(value || '')).trim().replace(/\s+kusky$/, '');
const categoryArt = t => art.find(a => categoryKey(a.label) === categoryKey(t.reference)) || art.find(a => categoryKey(a.label) === categoryKey(t.label)) || art.find(a => a.quick?.[0]?.[1] === String(t.url || '').split('/').filter(Boolean).pop()) || {};
const isSale = t => categoryKey(t.reference || t.label) === 'zlavy' || /\/collections\/vypredaj\/?$/.test(t.url || '');
const data=raw.map(t=>{const original=categoryArt(t);const brands=t.hasBrandMenu?t.brandsMenu:groups(t.brandText);brands.forEach(b=>{const old=(original.brands||[]).find(a=>a.href===b.href.split('/').pop());b.logo=old?.logo;});const quick=t.hasQuickMenu?t.quickMenu:String(t.quickText||'').split(/\r?\n/).filter(l=>l.trim()).map(pair);quick.forEach(q=>{const old=(original.quick||[]).find(a=>a[1]===q[1].split('/').pop());if(old?.[2])q[2]=old[2];});return {...t,pic:t.pic||original.pic,brands,quick,all:brands.map(b=>[b.name,b.href]),desktopGroups:t.hasDesktopMenu?t.desktopMenu:groups(t.desktopText)};});
const live = window.TuzexLiveBrands;
const embedded=JSON.parse(root.querySelector('[data-tx-brand-seed]')?.textContent||'{}');
const fallback=JSON.parse(root.querySelector('[data-tx-brand-fallback]')?.textContent||'{}');
data.forEach(t => {if(t.autoBrands){
 t.manualBrands=t.brands;
 const cached=live?.peek(t.brandSource),handle=String(t.brandSource).split('?')[0].split('/').filter(Boolean).pop();
 const rows=embedded[t.id] || cached?.rows || fallback[handle];
 if(rows && live){t.brands=live.combine(rows,String(t.excludedBrands||'').split(/\r?\n/).filter(Boolean)).map(b=>{const old=t.manualBrands.find(m=>live.normalize(m.name)===b.key);return {...b,href:live.destination(t.brandSource,b.values),models:old?.models||[],logo:old?.logo};});live.seed(t.brandSource,rows,embedded[t.id]?Date.now():cached?.time||0);t.liveStatus='ready';}
 else {t.brands=t.manualBrands;t.liveStatus='ready';}
}});
const TREE=data.filter(t=>t.catalog);
const link=url=>safeUrl(url);

const C=root.dataset.collectionsUrl;

  var SHOE = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M2.6 15.4h12.2c2.9 0 4.4-.8 6.6-2.3V16a1.4 1.4 0 0 1-1.4 1.4H2.6v-2Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M2.6 15.4V9.1l3.2.6 1.6 2.1 2.3-1 2.1 2.3 2.4-.7 1.5 1.9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV = '<svg class="tx-chev" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m6 3.5 4.5 4.5L6 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var MAG  = '<svg width="15" height="15" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="7" cy="7" r="5.2" stroke="currentColor" stroke-width="1.4"/><path d="M11 11l3.2 3.2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';

  data.filter(t=>t.desktop).forEach(t=>{ const item=root.querySelector('[data-tx-nav="'+t.id+'"]'); if(isSale(t)) item?.querySelector('.tx-nav-top')?.classList.add('tx-is-sale'); });
  data.filter(t=>t.desktop).forEach(t=>{
 const item=root.querySelector('[data-tx-nav="'+t.id+'"]');if(!item||(!t.desktopGroups.length&&!t.autoBrands))return;
 const mega=document.createElement('div');mega.className='tx-mega';
 if(t.referenceDesktop){
  mega.classList.add('tx-mega-reference');const columns=[];
  t.desktopGroups.forEach(g=>{if(!g.name.startsWith('+')||!columns.length)columns.push([]);columns[columns.length-1].push(g);});
  mega.style.gridTemplateColumns='repeat('+columns.length+',minmax(0,1fr))';mega.style.setProperty('--tx-menu-width',(columns.length*220+48)+'px');
  mega.innerHTML=columns.map(col=>'<div>'+col.map(g=>'<h4>'+esc(g.name.replace(/^\+/,''))+'</h4><ul>'+g.models.map(m=>{const brand=t.brands.find(b=>live?.normalize(b.name)===live?.normalize(m[0]));const brandGroup=['Podľa značky','Streetwear','Designer'].includes(g.name);const href=brandGroup&&brand?brand.href:link(m[1]);return '<li><a '+(/vypredaj/.test(href)?'class="tx-is-sale" ':'')+'href="'+esc(href)+'">'+esc(m[0])+'</a></li>';}).join('')+'</ul>').join('')+'</div>').join('');
 }else{
  mega.style.gridTemplateColumns='repeat('+Math.min(4,t.desktopGroups.length+(t.autoBrands?2:0))+', minmax(140px,1fr))';
  mega.innerHTML=t.desktopGroups.map(g=>'<div><h4>'+esc(g.name)+'</h4><ul>'+g.models.map(m=>'<li><a href="'+esc(link(m[1]))+'">'+esc(window.txModelLabel(g.name,m[0]))+'</a></li>').join('')+'</ul></div>').join('');
  if(t.autoBrands){const section=document.createElement('div');section.className='tx-live-brand-column';section.innerHTML='<h4>Značky</h4><ul data-tx-live-brands></ul><p class="tx-live-brand-status" role="status"></p>';mega.prepend(section);t.liveColumn=section;}
 }
 item.append(mega);
 function positionMega(){
   const bounds=item.getBoundingClientRect();
   const width=mega.offsetWidth;
   const left=Math.max(16,Math.min(bounds.left,document.documentElement.clientWidth-width-16));
   mega.style.left=(left-bounds.left)+'px';mega.style.right='auto';
   mega.style.maxHeight=Math.max(160,window.innerHeight-bounds.bottom-20)+'px';
 }
 item.addEventListener('pointerenter',()=>{positionMega();if(t.autoBrands)refreshBrands(t);},{signal});
 item.addEventListener('focusin',()=>{positionMega();if(t.autoBrands)refreshBrands(t);},{signal});
 window.addEventListener('resize',positionMega,{signal});
 positionMega();
});
  var tabsEl = root.querySelector('#' + 'catTabs');
  var listEl = root.querySelector('#' + 'catList');
  var subEl  = root.querySelector('#' + 'catSub');
  var panes  = root.querySelector('#' + 'catPanes');
  var picEl  = root.querySelector('#' + 'catPic');
  var built  = false;
  let activeTab=0;

  function esc(x){ return String(x).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;'); }
  function fold(x){ return x.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,''); }

  var resting = null;
  function paint(src, isBrand){
    if(!picEl) return;
    picEl.className = 'tx-cat-pic' + (isBrand ? ' tx-is-brand' : (src ? '' : ' tx-is-ph'));
    picEl.innerHTML = src
      ? '<img src="'+esc(src)+'" alt="">'
      : '<span class="tx-ph">'+SHOE+'<span>Obrázok</span></span>';
  }
  function rest(src, isBrand){ resting = {src:src, brand:!!isBrand}; paint(src, isBrand); }
  function peek(src){ paint(src, false); }
  function unpeek(){ if(resting) paint(resting.src, resting.brand); }
  function setPic(t){ rest(t.pic, false); }

  function renderSub(group){
    if(!group){ subEl.innerHTML=''; return; }
    var h = '<button class="tx-cat-back" type="button" id="catBack">← Späť</button>';
    h += '<h3>'+esc(group.name)+'</h3>';
    h += '<a class="tx-all" href="'+esc(link(group.href))+'">Zobraziť všetko →</a>';
    if(group.models.length){
      h += '<ul class="tx-cat-grid">';
      group.models.forEach(function(m){ h += '<li><a href="'+esc(link(m[1]))+'">'+esc(window.txModelLabel(group.name,m[0]))+'</a></li>'; });
      h += '</ul>';
    } else {
      h += '<p class="tx-empty">Táto značka zatiaľ nemá rozpad na modely.</p>';
    }
    subEl.innerHTML = h;
    var b = subEl.querySelector('#catBack');
    if(b) b.addEventListener('click', function(){ panes.classList.remove('tx-show-sub'); listEl.querySelector('[aria-current="true"]')?.focus(); });
  }

  function wireFilter(scopeSel){
    var input = listEl.querySelector('.tx-brandfilter input');
    if(!input) return;
    var none = listEl.querySelector('.tx-cat-none');
    input.addEventListener('input', function(){
      var q = fold(input.value.trim()), shown = 0;
      [].forEach.call(listEl.querySelectorAll(scopeSel), function(el){
        var hit = !q || fold(el.getAttribute('data-name')||'').indexOf(q) > -1;
        el.hidden = !hit; if(hit) shown++;
      });
      if(none) none.hidden = shown > 0;
    });
  }

  function renderTab(i){
    var t = TREE[i];activeTab=i;
    [].forEach.call(tabsEl.children, function(b,n){ b.setAttribute('aria-selected', n===i ? 'true':'false'); b.tabIndex=n===i?0:-1; b.id='tx-cat-tab-'+n; b.setAttribute('aria-controls','catPanes'); });
    panes.setAttribute('role','tabpanel'); panes.setAttribute('aria-labelledby','tx-cat-tab-'+i); panes.classList.toggle('tx-grid-mode', !!t.grid);
    panes.classList.remove('tx-show-sub');
    setPic(t);

    var h = '<div class="tx-cat-crumb"><b>'+esc(t.label)+'</b><span>Katalóg</span></div>';

    if(t.grid){
      h += '<div class="tx-brandfilter">'+MAG+'<label class="tx-skip" for="brandq">Hľadať značku</label>'+
           '<input id="brandq" type="search" placeholder="Hľadať značku, napr. Salomon" autocomplete="off" list="brandlist"></div>';
      h += '<datalist id="brandlist">'+t.all.map(function(b){ return '<option value="'+esc(b[0])+'">'; }).join('')+'</datalist>';
      h += '<div class="tx-brandgrid">';
      t.all.forEach(function(b){
        h += '<a class="tx-cat-item tx-plain" data-name="'+esc(b[0])+'" href="'+esc(link(b[1]))+'"><span class="tx-name">'+esc(b[0])+'</span></a>';
      });
      h += '</div><p class="tx-cat-none" hidden>Takú značku tu nemáme. Skúste vyhľadávanie v obchode.</p>';
      listEl.innerHTML = h; listEl.scrollTop = 0;
      wireFilter('.tx-brandgrid .tx-cat-item');
      subEl.innerHTML = '';
      return;
    }

    h += '<div class="tx-cat-head">Rýchly výber</div>';
    if(t.autoBrands&&t.liveStatus!=='ready')h+='<p class="tx-live-brand-status" role="status">'+brandStatus(t)+'</p>';
    t.quick.forEach(function(q){
      h += '<a class="tx-cat-item tx-plain"' + (q[2] ? ' data-pic="'+esc(q[2])+'"' : '') +
           ' href="'+esc(link(q[1]))+'"><span class="tx-name">'+esc(q[0])+'</span></a>';
    });
    if(t.brands.length){
      h += '<div class="tx-cat-head">Značky</div>';
      h += '<div class="tx-brandfilter">'+MAG+'<label class="tx-skip" for="brandq">Hľadať značku</label>'+
           '<input id="brandq" type="search" placeholder="Hľadať značku" autocomplete="off" list="brandlist"></div>';
      h += '<datalist id="brandlist">'+t.brands.map(function(b){ return '<option value="'+esc(b.name)+'">'; }).join('')+'</datalist>';
      t.brands.forEach(function(b,n){
        h += '<button class="tx-cat-item" type="button" data-brand="'+n+'" data-name="'+esc(b.name)+'">'+
             '<span class="tx-name">'+esc(b.name)+'</span>'+(t.autoBrands?'<span class="tx-brand-count">'+b.count+'</span>':'')+CHEV+'</button>';
      });
      h += '<p class="tx-cat-none" hidden>Takú značku tu nemáme.</p>';
    }
    listEl.innerHTML = h; listEl.scrollTop = 0;

    renderSub(t.brands.length ? t.brands[0] : null);
    var first = listEl.querySelector('[data-brand="0"]');
    if(first) first.setAttribute('aria-current','true');

    [].forEach.call(listEl.querySelectorAll('[data-pic]'), function(el){
      var src = el.getAttribute('data-pic');
      el.addEventListener('mouseenter', function(){ peek(src); });
      el.addEventListener('focus', function(){ peek(src); });
      el.addEventListener('mouseleave', unpeek);
      el.addEventListener('blur', unpeek);
    });

    [].forEach.call(listEl.querySelectorAll('[data-brand]'), function(btn){
      btn.addEventListener('click', function(){
        [].forEach.call(listEl.querySelectorAll('[data-brand]'), function(o){ o.removeAttribute('aria-current'); });
        btn.setAttribute('aria-current','true');
        var b = t.brands[+btn.getAttribute('data-brand')];
        renderSub(b);
        rest(b.logo || t.pic, !!b.logo); btn.setAttribute('aria-expanded','true');
        panes.classList.add('tx-show-sub');
        subEl.scrollTop = 0; if(matchMedia('(max-width:719px)').matches) subEl.querySelector('button')?.focus();
      });
    });
    wireFilter('[data-brand]');
  }

  function build(){
    if(built) return;
    tabsEl.innerHTML = TREE.map(function(t,i){
      return '<button class="tx-cat-tab'+(isSale(t)?' tx-is-sale':'')+'" type="button" role="tab" aria-selected="'+(i===0)+'">'+esc(t.label)+'</button>';
    }).join('');
    [].forEach.call(tabsEl.children, function(b,i){ b.addEventListener('click', function(){ renderTab(i);if(TREE[i].autoBrands)refreshBrands(TREE[i]); }); });
    renderTab(0);
    built = true;
  }

  var catalog  = root.querySelector('#' + 'catalog');
  var scrim    = root.querySelector('#' + 'scrim');
  var catbtn   = root.querySelector('#' + 'catbtn');
  var catClose = root.querySelector('#' + 'catClose');

  const portal=document.createElement('div');portal.className='tx-redesign tx-site-header tx-modal-portal';
  document.body.append(portal);portal.append(scrim,catalog);
  if(!TREE.length)catbtn.hidden=true;
  function openCat(){
    if(!TREE.length)return;
    build();
    catalog.hidden = false; scrim.hidden = false;
    requestAnimationFrame(function(){ catalog.classList.add('tx-open'); scrim.classList.add('tx-open'); });
    catbtn.setAttribute('aria-expanded','true');
    previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
    catClose.focus();
    if(TREE[activeTab]?.autoBrands)refreshBrands(TREE[activeTab]);
  }
  function closeCat(){
    catalog.classList.remove('tx-open'); scrim.classList.remove('tx-open');
    catbtn.setAttribute('aria-expanded','false');
    document.body.style.overflow = previousOverflow;
    catbtn.focus();
    window.setTimeout(function(){
      if(!catalog.classList.contains('tx-open')){ catalog.hidden = true; scrim.hidden = true; }
    }, 360);
  }
  catbtn.addEventListener('click', function(){
    if(catalog.classList.contains('tx-open')) closeCat(); else openCat();
  });
  catClose.addEventListener('click', closeCat);
  scrim.addEventListener('click', closeCat);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && catalog.classList.contains('tx-open')) { e.preventDefault(); closeCat(); } }, {signal});
  catalog.addEventListener('click', function(e){ if(e.target.closest('a')) closeCat(); });


  tabsEl.addEventListener('keydown', event => {
    const keys=['ArrowLeft','ArrowRight','Home','End'];
    if(!keys.includes(event.key))return;
    event.preventDefault();const tabs=[...tabsEl.children];const index=tabs.indexOf(event.target);
    const next=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
    renderTab(next);tabs[next].focus();if(TREE[next].autoBrands)refreshBrands(TREE[next]);
  });
  catalog.addEventListener('keydown',event=>{
    if(event.key!=='Tab')return;
    const items=[...catalog.querySelectorAll('a[href],button,input,[tabindex="0"]')].filter(e=>!e.disabled&&e.getClientRects().length&&!e.closest('[hidden]'));
    const first=items[0],last=items[items.length-1];
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
  });
  root.querySelectorAll('.tx-nav > li').forEach(item=>{
    item.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();item.querySelector('.tx-nav-top').blur();catbtn.focus();}});
  });

  function brandStatus(t){return t.liveStatus==='error'?'Značky sa nepodarilo načítať. Otvorte celú kategóriu.':t.liveStatus==='ready'&&!t.brands.length?'Aktuálne nie sú dostupné značky.':'Načítavam značky…';}
  function updateBrandViews(t){
    if(t.liveColumn){
      t.liveColumn.querySelector('ul').innerHTML=t.brands.slice(0,16).map(b=>'<li><a href="'+esc(b.href)+'"><span>'+esc(b.name)+'</span><span class="tx-brand-count">'+b.count+'</span></a></li>').join('');
      const status=t.liveColumn.querySelector('[role="status"]');status.textContent=t.liveStatus==='ready'&&t.brands.length?'':brandStatus(t);
    }
    if(!built||TREE[activeTab]!==t)return;
    const focused=document.activeElement;
    const hadFocus=listEl.contains(focused)||subEl.contains(focused);
    const selected=listEl.querySelector('[aria-current="true"]')?.dataset.name;
    const filter=listEl.querySelector('.tx-brandfilter input')?.value||'';
    const scroll=listEl.scrollTop;
    const showing=panes.classList.contains('tx-show-sub');
    renderTab(activeTab);
    const btn=[...listEl.querySelectorAll('[data-brand]')].find(b=>b.dataset.name===selected);
    if(btn){
      listEl.querySelectorAll('[aria-current]').forEach(b=>b.removeAttribute('aria-current'));
      btn.setAttribute('aria-current','true');renderSub(t.brands[Number(btn.dataset.brand)]);
      if(showing)panes.classList.add('tx-show-sub');
    }
    const input=listEl.querySelector('.tx-brandfilter input');
    if(input){input.value=filter;input.dispatchEvent(new Event('input'));}
    listEl.scrollTop=scroll;
    if(hadFocus){if(focused?.matches('input')&&input)input.focus();else if(showing&&btn)subEl.querySelector('button')?.focus();else (btn||input||catClose).focus();}
  }
  async function refreshBrands(t){
    if(!live||t.livePending||signal.aborted||Date.now()-(t.lastRead||0)<60000)return;
    t.livePending=true;t.lastRead=Date.now();
    try{
      const rows=await live.load(t.brandSource);if(signal.aborted)return;
      const excluded=String(t.excludedBrands||'').split(/\r?\n/).filter(Boolean);
      const brands=live.combine(rows,excluded).map(b=>{
        const old=t.manualBrands.find(m=>live.normalize(m.name)===b.key);
        return {...b,href:live.destination(t.brandSource,b.values),models:old?.models||[],logo:old?.logo};
      });
      const changed=JSON.stringify(brands)!==JSON.stringify(t.brands)||t.liveStatus!=='ready';
      t.brands=brands;t.liveStatus='ready';t.lastRead=Date.now();if(changed)updateBrandViews(t);
    }catch(error){if(!signal.aborted){if(!t.brands.length)t.liveStatus='error';updateBrandViews(t);}}
    finally{t.livePending=false;}
  }
  data.filter(t=>t.autoBrands).forEach(t=>{if(t.liveColumn)updateBrandViews(t);});
  window.setTimeout(()=>{if(!signal.aborted)data.filter(t=>t.autoBrands).forEach(refreshBrands);},1200);
  const refreshTimer=window.setInterval(()=>{
    if(document.visibilityState!=='visible')return;
    data.filter(t=>t.autoBrands).forEach(t=>{
      const item=root.querySelector('[data-tx-nav="'+t.id+'"]');
      if((catalog.classList.contains('tx-open')&&TREE[activeTab]===t)||item?.matches(':hover,:focus-within'))refreshBrands(t);
    });
  },60000);
  signal.addEventListener('abort',()=>clearInterval(refreshTimer),{once:true});
  document.addEventListener('shopify:block:select',event=>{const i=TREE.findIndex(t=>t.id===event.detail.blockId);if(i>=0){if(!catalog.classList.contains('tx-open'))openCat();renderTab(i);if(TREE[i].autoBrands)refreshBrands(TREE[i]);}},{signal});
  document.addEventListener('shopify:section:unload' ,event=>{if(event.target.contains(root)){if(catalog.classList.contains('tx-open'))document.body.style.overflow=previousOverflow;portal.remove();controller.abort();}},{signal});
}
function initialize(scope){scope.querySelectorAll('[data-tx-header]').forEach(init)}
initialize(document);document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();